<template>
  <div>
    <label v-if="label">{{ label }}</label>
    <div v-if="image_url">
      <div>
        <div :style="{ width: width + 'px', height: height + 'px', background: background_color }" class="uploaded">
          <img :src="image_url">
          <CButton class="removeButton" size="sm" color="danger" @click="removeImage">X</CButton>
        </div>
        
      </div>
      <small class="sm">{{ description }}</small>
    </div>
    <div v-if="!image_url && default_image">
      <div>
        <div :style="{ width: width + 'px', height: height + 'px', background: background_color }" class="uploaded">
          <img :src="default_image">
        </div>
      </div>
    </div>
    <CInputFile
      v-if="!image_url"
      :description="description"
      @change="onFileSelected"
      class="mt-2"
    />
  </div>
</template>

<script>
import * as strftime from 'strftime'

export default {
  name: 'ImageUpload',
  props: {
    value: { type: String, default: null },
    description: { type: String, default: '' },
    width: { type: Number, default: 100 },
    height: { type: Number, default: 100 },
    background_color: { type: String, default: '#ffffff' },
    label: { type: String, default: '' },
    default_image: { type: String, default: '' }
  },
  data() {
    return {
      image_url: this.value,
      imageData: {},
    }
  },
  watch: {
    value: {
      handler: function(value) {
        this.image_url = value
      },
    }
  },
  methods: {
    removeImage() {
      this.image_url = ''
      this.$emit('input', this.image_url)
    },

    onFileSelected(event) {
      this.imageData = event[0]
      if (this.imageData.type.includes("image/")) {
        this.UploadImage()
      } else {
        alert('The selected file is not a known image type. Please try again.')
      }
    },

    UploadImage() {
      const key = 'uploads/' + strftime('%Y/%m/%d', new Date()) + '/' + this.imageData.name
      this.$api
        .post('sign-image-url', { key, file_type: this.imageData.type })
        .then(res => {
          const url = res.data.signed_url
          fetch(url, {
                method: 'PUT',
                headers: {
                    'content-type': this.imageData.type,
                    'x-amz-acl': 'public-read'
                },
                body: this.imageData
            })
          .then(() => {
              this.image_url = res.data.public_url
              this.$emit('input', this.image_url)
            })
        })

    },

  },
}
</script>

<style>
  .removeButton {
    position: absolute;
    margin-left: -15px;
    margin-top:  -10px;
    border:  1px solid grey;
  }
  .uploaded img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }
</style>

